import React, { createContext } from "react";
import { useHistory } from "react-router-dom";
import { trackNavigation } from "lib/analytics";

export const NavigationContext = createContext();

const Navigation = ({ children }) => {
  const history = useHistory();

  function target(newContext) {
    return newContext ? "_blank" : "_top";
  }

  const goTo = path => {
    history.push(path);
    trackNavigation();
  };

  const redirect = url => {
    open(url, target(false));
    trackNavigation();
  };

  const redirectAdmin = path => {
    open(`shopify://admin${path}`, target(false));
    trackNavigation();
  };

  const replaceURL = path => {
    history.replace(path);
    trackNavigation();
  };

  const contextObject = {
    goTo,
    redirect,
    redirectAdmin,
    replaceURL
  };

  return (
    <NavigationContext.Provider value={contextObject}>
      {children}
    </NavigationContext.Provider>
  );
};

export default Navigation;
